<template>
  <div class="row g-2 wrap">
    <Badge v-for="(badge, i) in badges" :key="`${badge.value}_${i}`" v-bind="badge" />
  </div>
</template>

<script>
import Badge from '@/components/Badge'

export default {
  props: {
    item: Object,
    theme: String,
    type: String,
    id: {
      type: String,
      defualt: '',
    },
    placeholder: String,
    source: String,
  },
  data() {
    return {
      items: [],
    }
  },
  computed: {
    badges() {
      let items = this.$path(`${this.source || this.id}`, this.item) || []

      items = (items instanceof Array ? items : [items]).map(i => ({ value: i.value || i }))

      return items.map(({ value, ...rest }) => {
        let test =
          this.placeholder || this.$t(`${this.$attrs.i18nPrefix ? `${this.$attrs.i18nPrefix}:${value}` : value}`)

        return {
          value: test,
          theme: this.theme,
          type: this.type,
          ...rest,
        }
      })
    },
  },
  components: {
    Badge,
  },
}
</script>

<style lang="scss"></style>
